<template>
  <q-banner rounded :dense="!!iconType" class="banner q-mt-sm" :class="type">
    <template v-slot:avatar v-if="icon">
      <q-icon :name="iconType" size="xs" />
    </template>
    <div :class="{ 'text-weight-bold': iconType }">
      <slot />
    </div>
  </q-banner>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    type: {
      type: String,
      default: '',
      validator: (color) => ['success', 'warning', 'danger', 'info', ''].includes(color),
    },
    icon: Boolean,
  },
  computed: {
    iconType() {
      switch (this.type) {
        case 'success':
          return 'check_circle';
        case 'warning':
          return 'error';
        case 'danger':
          return 'cancel';
        case 'info':
          return 'info';
        default:
          return '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~quasar/src/css/variables';

.banner {
  background-color: $grey-3;
}
.success {
  background-color: rgba($positive, 0.15);
  color: $positive;
}
.info {
  background-color: rgba($info, 0.15);
  color: $info;
}
.warning {
  background-color: rgba($warning, 0.25);
  color: darken($warning, 20%);
}
.danger {
  background-color: rgba($negative, 0.15);
  color: $negative;
}
</style>
